/* ASCII-safe text normalization for PDF generation and text processing */
export const norm = (s) =>
  s
    .replace(/[–—]/g, '-')
    .replace(/['']/g, "'")
    .replace(/[""]/g, '"')
    .replace(/[^ -~\u00A0-\u00FF]+/g, '');
